// extracted by mini-css-extract-plugin
var _1 = "BeastbuilderTutorial__accent--N40YB";
var _2 = "BeastbuilderTutorial__bb1--FMLJb BeastbuilderTutorial__main--vr7yL";
var _3 = "BeastbuilderTutorial__bb2--GFMHi BeastbuilderTutorial__main--vr7yL";
var _4 = "BeastbuilderTutorial__bb3--jql8h BeastbuilderTutorial__main--vr7yL";
var _5 = "BeastbuilderTutorial__bb3Simplified--iUUHj BeastbuilderTutorial__bb3--jql8h BeastbuilderTutorial__main--vr7yL";
var _6 = "BeastbuilderTutorial__bg--c4DjJ";
var _7 = "BeastbuilderTutorial__button--S8uGQ";
var _8 = "BeastbuilderTutorial__content--GlPpU fontSize__profileUsername--AvuOr";
var _9 = "BeastbuilderTutorial__demo--nt_Xi BeastbuilderTutorial__main--vr7yL";
var _a = "BeastbuilderTutorial__icon--YXmP7";
var _b = "BeastbuilderTutorial__main--vr7yL";
var _c = "BeastbuilderTutorial__profile--pgCJ4 BeastbuilderTutorial__main--vr7yL";
export { _1 as "accent", _2 as "bb1", _3 as "bb2", _4 as "bb3", _5 as "bb3Simplified", _6 as "bg", _7 as "button", _8 as "content", _9 as "demo", _a as "icon", _b as "main", _c as "profile" }
